import Grid from "@mui/material/Grid";

import {
  CmpTypographyField,
  CmpRadioButton,
  CmpDatePickerField,
  CmpSelectField,
  CmpInputField,
  CmpCheckboxField,
} from "../../../Component/Common/ToolBox/ToolBox.js";

export default function WmsContent({
  DetailReportRadioBtn,
  selectedOption,
  sBufferObj,
  xtitle = "",
  sDetailSelectReportData,
  fDetailSelectedReport,
  fCompr_ToDt,
  fCompr_FromDt,
  fComprSales_ToDt,
  fComprSales_FromDt,
  fDetailSalesAbvCost,
  fDetailSalesBelowCost,
  fDetailSalesAboveBtCostFrom,
  fDetailSalesAboveBtCostTo,
  fSummaryLocCustCheckBox,
  //View
}) {
  return (
    <form className="" id="WMSSalesReportContent">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <CmpTypographyField
            xcomponent={"h1"}
            xText={xtitle}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="SUMMARY"
                label="Summary Report"
                checked={selectedOption === "SUMMARY"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="DETAIL"
                label="Detail Report"
                checked={selectedOption === "DETAIL"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="ANALYSIS"
                label="Analysis Report"
                checked={selectedOption === "ANALYSIS"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="COMPARISON"
                label="Comparison Report"
                checked={selectedOption === "COMPARISON"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={2} md={4}>
              <CmpTypographyField xcomponent={"span"} xText={"Report"} />
            </Grid>
            <Grid item xs={12} sm={4} md={8}>
              <CmpSelectField
                xLabelText="DetailSelectedReport"
                xValue={sBufferObj.DetailSelectedReport}
                xOnChange={fDetailSelectedReport}
                xName={"DetailSelectedReport"}
                xData={sDetailSelectReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
                // xOnKeyUp={xKeyIInboundGrn}
              />
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            selectedOption === "COMPARISON"
              ? ""
              : "hide-radio-buttonStockReport"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={4} md={4}>
              <CmpTypographyField xcomponent={"span"} xText={"Sales"} />
            </Grid>
            <Grid item xs={6} sm={4} md={4}>
              <CmpDatePickerField
                xValue={sBufferObj.sComprSales_FromDt}
                xOnChange={fComprSales_FromDt}
                xName={"sComprSales_FromDt"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={4}>
              <CmpDatePickerField
                xValue={sBufferObj.sComprSales_ToDt}
                xOnChange={fComprSales_ToDt}
                xName={"sComprSales_ToDt"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid> */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            selectedOption === "COMPARISON"
              ? ""
              : "hide-radio-buttonStockReport"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={4} md={4}>
              <CmpTypographyField xcomponent={"span"} xText={"Compr"} />
            </Grid>
            <Grid item xs={6} sm={4} md={4}>
              <CmpDatePickerField
                xValue={sBufferObj.sCompr_FromDt}
                xOnChange={fCompr_FromDt}
                xName={"sCompr_FromDt"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={4}>
              <CmpDatePickerField
                xValue={sBufferObj.sCompr_ToDt}
                xOnChange={fCompr_ToDt}
                xName={"sCompr_ToDt"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            selectedOption === "DETAIL" &&
            sBufferObj.DetailSelectedReport === "DTIL_SAL_ABOV_COST"
              ? ""
              : "hide-radio-buttonStockReport"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={4} md={4}>
              <CmpTypographyField xcomponent={"span"} xText={"Detail"} />
            </Grid>
            <Grid item xs={12} sm={8} md={8}>
              <CmpInputField
                xValue={sBufferObj.sDetailSalesAbvCost}
                xType={"number"} // text/number/password
                xName={"sDetailSalesAbvCost"}
                xReadOnly={false}
                xOnChange={fDetailSalesAbvCost}
                xError={false}
                xErrorMessage={""}
                // xOnKeyUp={xKey}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            selectedOption === "DETAIL" &&
            sBufferObj.DetailSelectedReport === "DTIL_SAL_BELOW_COST"
              ? ""
              : "hide-radio-buttonStockReport"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={4} md={4}>
              <CmpTypographyField xcomponent={"span"} xText={"Detail"} />
            </Grid>
            <Grid item xs={12} sm={8} md={8}>
              <CmpInputField
                xValue={sBufferObj.sDetailSalesBelowCost}
                xType={"number"} // text/number/password
                xName={"sDetailSalesBelowCost"}
                xReadOnly={false}
                xOnChange={fDetailSalesBelowCost}
                xError={false}
                xErrorMessage={""}
                // xOnKeyUp={xKey}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            selectedOption === "DETAIL" &&
            sBufferObj.DetailSelectedReport === "DTIL_SAL_ABOV_BT_COST"
              ? ""
              : "hide-radio-buttonStockReport"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={4} md={4}>
              <CmpTypographyField xcomponent={"span"} xText={"Detail"} />
            </Grid>
            <Grid item xs={6} sm={4} md={4}>
              <CmpInputField
                xValue={sBufferObj.sDetailSalesAboveBtCostFrom}
                xType={"number"} // text/number/password
                xName={"sDetailSalesAboveBtCostFrom"}
                xReadOnly={false}
                xOnChange={fDetailSalesAboveBtCostFrom}
                xError={false}
                xErrorMessage={""}
                // xOnKeyUp={xKey}
              />
            </Grid>
            <Grid item xs={1} sm={1} md={1} className="text-center">
              <CmpTypographyField
                xcomponent={"span"}
                xText={"~"}
                xfontSize={"20px"}
              />
            </Grid>
            <Grid item xs={5} sm={3} md={3}>
              <CmpInputField
                xValue={sBufferObj.sDetailSalesAboveBtCostTo}
                xType={"number"} // text/number/password
                xName={"sDetailSalesAboveBtCostTo"}
                xReadOnly={false}
                xOnChange={fDetailSalesAboveBtCostTo}
                xError={false}
                xErrorMessage={""}
                // xOnKeyUp={xKey}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            selectedOption === "SUMMARY" &&
            sBufferObj.DetailSelectedReport === "SMRY_LOC"
              ? ""
              : "hide-radio-buttonStockReport"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={4} md={4}>
              <CmpTypographyField xcomponent={"span"} xText={"Pivot"} />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <CmpCheckboxField
                xChecked={sBufferObj.sSummaryLocCustCheckBox === "Y"}
                xOnChange={fSummaryLocCustCheckBox}
                xDisabled={false}
                xName={"sSummaryLocCustCheckBox"}
                xNameField={"Loc-Wise"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
